import { motion } from "framer-motion";
import { Flag } from "lucide-react";

const STATEMENTS = [
  "A student can become a founder.",
  "A small entrepreneur can build a scalable company.",
  "A village idea can become a national business.",
  "A local business can become a global company.",
  "A business can become a source of employment for hundreds or thousands of people.",
];

export function Vision2047() {
  return (
    <section data-testid="vision-2047-section" className="relative py-20 sm:py-28 lg:py-36 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(0,176,255,0.05),transparent_55%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
        >
          <div className="inline-flex items-center gap-2 glass px-4 py-2 rounded-full mb-8">
            <Flag className="w-4 h-4 text-[#FF8800]" />
            <span className="font-mono-tech text-[10px] tracking-[0.3em] text-slate-300 uppercase">The Long Horizon</span>
          </div>
          <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight" data-testid="vision-2047-headline">
            <span className="text-gradient-india">INDIA @ 2047</span>
          </h2>
          <p className="mt-4 font-mono-tech text-xs sm:text-sm tracking-[0.4em] text-slate-400 uppercase" data-testid="vision-2047-sub">
            100 Years of Independence
          </p>
          <p className="mt-8 text-base sm:text-lg text-slate-300 leading-relaxed max-w-3xl mx-auto">
            By India's 100th year of independence, LaunchLab envisions an India where
            entrepreneurship is not limited to a small group of people. An India where:
          </p>
        </motion.div>

        <div className="mt-14 max-w-3xl mx-auto space-y-4 text-left" data-testid="vision-2047-statements">
          {STATEMENTS.map((s, i) => (
            <motion.div
              key={s}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="glass rounded-xl px-6 py-5 flex items-center gap-4 hover:border-[#FF8800]/30 transition-colors"
              data-testid={`vision-2047-statement-${i}`}
            >
              <span
                className="font-display font-extrabold text-lg shrink-0"
                style={{ color: ["#FF8800", "#00B0FF", "#00E676", "#FF8800", "#00E676"][i] }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-base sm:text-xl font-semibold text-white leading-snug">{s}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
